import axios from 'axios';

export default async function checkEmail(email: string) {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/count?email=${email}`);
  return response.data === 0;
}
